import { jsx } from "@ecopages/jsx/jsx-runtime";
import { cx } from "@/lib/cx";
import { Intrinsic } from "@/lib/intrinsic";
export function RuiHeadline(props) {
  const {
    children,
    as = "h2",
    size = "md",
    class: className,
    ...host
  } = props;
  return /* @__PURE__ */jsx(Intrinsic, {
    as,
    ...host,
    class: cx("rui-headline", size !== false && `rui-headline--size-${size}`, className),
    children
  });
}